import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {AuthService, UserIdService} from '@spartacus/core';
import { take, switchMap } from 'rxjs/operators';

@Injectable( )
export class UserIdInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private userIdService: UserIdService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url.includes(`/occ/v2/`)) {
      return this.userIdService.getUserId().pipe(
        take(1),
        switchMap((userId) => {
          let modifiedRequest = request;

          if (userId && userId !== 'anonymous') {
            modifiedRequest = request.clone({
              setHeaders: {
                'sap-commerce-cloud-user-id': userId,
              },
            });
          }
          return next.handle(modifiedRequest);
        })
      );
    } else {
      return next.handle(request);
    }
  }
}
